import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Ce trebuie să știți',
        table: {
            rows: [
                ['Operatorul', 'SC EVOO MEDICAL SRL, contact@evoomedical.ro'],
                ['Scopul', 'Siguranța pacienților, a personalului și a bunurilor; prevenirea și dovedirea incidentelor'],
                ['Temeiul', 'Interesul legitim — art. 6 alin. (1) lit. f) din Regulamentul (UE) 2016/679; Legea nr. 190/2018, art. 5'],
                ['Zonele', 'Intrările, recepția și sala de așteptare, holurile, scările, curtea și parcarea'],
                ['Cât păstrăm', 'Cel mult 30 de zile; înregistrările unui incident se păstrează până la soluționarea lui'],
                ['Cine are acces', 'Numai persoanele desemnate de conducere; fiecare vizionare se trece în registru. Înregistrările se dau doar autorităților, la cerere legală.'],
                ['Drepturile', 'Acces la imaginile în care apăreți, ștergere, restricționare, opoziție — la gdpr@evoomedical.ro']
            ]
        }
    },
    {
        title: 'Afișajul de la intrare',
        text: 'La fiecare intrare se afișează o pictogramă cu o cameră video, numele operatorului și datele de contact, cu trimitere la această pagină — primul strat de informare. Pagina de față este al doilea strat.'
    }
];

function SupravegherVideo() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Supravegherea video"
            intro="Clădirea are camere de supraveghere în zonele de acces și de circulație. Nu există camere în cabinete, în sălile de tratament, în vestiare sau în grupurile sanitare."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default SupravegherVideo;
